






































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import CouponApi from '@/api/marketing/coupon/index'
@Component
export default class CouponSelect extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return []
    }
  })
  selectedItems!: string[]

  @Prop({
    type: Boolean,
    default: true
  })
  IsMultiple!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  ExcludeBonusCoupon!: boolean

  modal1: boolean = false

  pager = {
    total: 0,
    pageSize: 10,
    pageIndex: 1
  }

  data = []
  get columns() {
    var data: any[] = [
      {
        title: '优惠券名称',
        width: 350,
        key: 'name'
      },
      {
        title: '优惠券类型',
        key: 'couponTypeDisplayName'
      },
      {
        title: '有效期',
        key: 'validDate'
      },
      {
        title: '数量',
        key: 'circulation'
      }
    ]
    if (this.IsMultiple) {
      data.splice(0, 0, {
        type: 'selection',
        width: 60,
        align: 'center'
      })
    }
    return data
  }
  async mounted() {}
  @Watch('modal1')
  async modalShowChange(show) {
    if (show) await this.loadGoodsList()
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadGoodsList()
  }
  async loadGoodsList() {
    CouponApi.getList(this.pager.pageSize, this.pager.pageIndex, this.ExcludeBonusCoupon).then(
      res => {
        this.pager.total = res.data.totalCount
        let result = []
        res.data.items.forEach(element => {
          element['_disabled'] =
            this.selectedItems.findIndex(x => x == element.id) > -1
          result.push(element)
        })
        this.data = result
      }
    )
  }
  currentChange(currentRow, oldCurrentRow) {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', {
        id: currentRow.id,
        name: currentRow.name,
        couponType: currentRow.couponType,
        couponTypeDisplayName: currentRow.couponTypeDisplayName,
        validDate: currentRow.validDate,
        value: currentRow.discountValue,
        limitValue: currentRow.limitValue
      })
      this.modal1 = false
    }
  }
  ok() {
    this.$emit('on-change', (this.$refs.selection as any).getSelection())
  }
}
